var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('Tag',{staticClass:"noborder",attrs:{"size":_vm.size,"color":_vm.data.color}},[_vm._v(_vm._s(_vm.data.label))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }